import React from 'react';
import ModalPolityka from "./Modals/ModalPolityka"
import ModalZastrzezenia from "./Modals/ModalZastrzezenia"

import IconTwitter from "../images/icon-twitter.png"
import IconFacebook from "../images/icon-facebook.png"
import IconYoutube from "../images/icon-youtube.png"
import IconInstagram from "../images/icon-instagram.png"

const Footer = () => {

	const [modPolitykaShow, setModPolitykaShow] = React.useState(false);
	const [modZastrzezeniaShow, setModZastrzezeniaShow] = React.useState(false);



	return (
    <>
      <footer className="footer py-5">
        <div className="container text-center">
          <button
            className="button-blank"
            onClick={() => setModPolitykaShow(true)}
          >
            Privacy policy
          </button>
          <button
            className="button-blank"
            onClick={() => setModZastrzezeniaShow(true)}
          >
            Legal disclaimer
          </button>

          <br />

          <a
            href="https://twitter.com/PKN_ORLEN"
            className="icon-link"
            target="_blank"
            rel="noreferrer"
          >
            <img src={IconTwitter} alt="Twitter" />
          </a>
          <a
            href="https://www.facebook.com/ORLEN.Official/"
            className="icon-link"
            target="_blank"
            rel="noreferrer"
          >
            <img src={IconFacebook} alt="Facebook" />
          </a>
          <a
            href="https://www.youtube.com/c/PKNORLENSA_official"
            className="icon-link"
            target="_blank"
            rel="noreferrer"
          >
            <img src={IconYoutube} alt="Youtube" />
          </a>
          <a
            href="https://www.instagram.com/pkn.orlen/"
            className="icon-link"
            target="_blank"
            rel="noreferrer"
          >
            <img src={IconInstagram} alt="Instagram" />
          </a>
        </div>
      </footer>

      <ModalPolityka
        show={modPolitykaShow}
        handleclose={() => setModPolitykaShow(false)}
      />
      <ModalZastrzezenia
        show={modZastrzezeniaShow}
        handleclose={() => setModZastrzezeniaShow(false)}
      />
    </>
  )
}

export default Footer
